import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Modal } from '@resurs/midas-react'
import { rejectedAnimation } from '../../../../assets/animations'
import { getText } from '../../../../internal/TextLabels'
import Page from '../../../../internal/Page'
import { SignDigitalAgreement } from '../ApplicationSignPage/UI/SignDigitalAgreement'

const RetryDigitalAgreementSigningModal = props => {
  return (
    <Modal {...props}>
      <div style={{ marginBottom: '3rem', width: 700, height: 550 }}>
        <Page type="danger">
          <div
            style={{
              padding: '1rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex' }}>
              <img
                style={{ margin: '1rem 1rem 1rem 0' }}
                src={rejectedAnimation}
                alt="Reject animation"
              />
              <h6 style={{ margin: '2.2rem 1rem 0 0' }}>
                {props.isCanceled
                  ? getText('payApply.signing.abort')
                  : getText('payApply.sign.digitalAgreement.declined')}
              </h6>
            </div>
          </div>
        </Page>
        <Page>
          <div style={{ padding: '1rem' }}>
            <SignDigitalAgreement
              disabled={!!props.disabled}
              onNext={props.onNext}
              isNewPageLoading={props.isLoading}
              customer={props.customer}
              coCustomer={props.coCustomer}
            />
          </div>
        </Page>
      </div>
    </Modal>
  )
}

RetryDigitalAgreementSigningModal.propTypes = {
  disabled: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  customer: PropTypes.object,
  coCustomer: PropTypes.object,
  isCanceled: PropTypes.bool,
}

RetryDigitalAgreementSigningModal.defaultProps = {
  disabled: false,
  isLoading: false,
  isCanceled: false,
  customer: undefined,
  coCustomer: undefined,
}

export default connect(state => ({
  isLoading: state.payApply.wizard.newPageLoading,
}))(RetryDigitalAgreementSigningModal)
